module.exports = __webpack_public_path__ + "assets/img/blast_1.ea82df83.png";